import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  type FormControlProps,
  type FormErrorMessageProps,
  type FormHelperTextProps,
  type FormLabelProps,
} from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export interface FormFieldProps {
  controlSx?: FormControlProps;
  isInvalid?: boolean;
  isRequired?: boolean;
  label?: any;
  labelSx?: FormLabelProps;
  error?: any;
  errorSx?: FormErrorMessageProps;
  helper?: any;
  helperSx?: FormHelperTextProps;

  floating?: boolean;
}

export function FormField({
  controlSx,
  isRequired,
  isInvalid,
  label,
  labelSx,
  children,
  error,
  errorSx,
  helper,
  helperSx,
  floating,
}: PropsWithChildren<FormFieldProps>) {
  return (
    <FormControl {...controlSx} {...{ isRequired, isInvalid }}>
      {!floating && label && (
        <FormLabel {...labelSx} fontWeight="bold">
          {label}
        </FormLabel>
      )}
      {children}
      {floating && label && (
        <FormLabel {...labelSx} fontWeight="bold">
          {label}
        </FormLabel>
      )}
      {error && <FormErrorMessage {...errorSx}>{error}</FormErrorMessage>}
      {helper && !error && (
        <FormHelperText {...helperSx}>{helper}</FormHelperText>
      )}
    </FormControl>
  );
}
